export const licenseRenewURL = 'https://www.portainer.io/renew';
export const contactPortainerURL = 'https://www.portainer.io/contact';
